// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.GoalSettingCycle')
class Toolbox__GoalSettingCycle {
    @jsonProperty(() => Toolbox__GoalSettingCycle.Id)
    id: Toolbox__GoalSettingCycle.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "startDate", "status", "status$id", "goalsDeadline", "selfReviewDeadline", "managerReviewDeadline", "goalSettings", "previousCycle", "previousCycleId", "nextCycle", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "startDate", "status", "status$id", "goalsDeadline", "selfReviewDeadline", "managerReviewDeadline", "goalSettings", "previousCycle", "previousCycleId", "nextCycle", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "startDate", "status", "goalsDeadline", "selfReviewDeadline", "managerReviewDeadline", "goalSettings", "previousCycle", "previousCycleId", "nextCycle", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "startDate": "Date", "status": "Toolbox.GoalSettingCycleStatus", "status$id": "string", "goalsDeadline": "Date", "selfReviewDeadline": "Date", "managerReviewDeadline": "Date", "goalSettings": "Toolbox.GoalSetting[]", "previousCycle": "Toolbox.GoalSettingCycle", "previousCycleId": "Toolbox.GoalSettingCycle.Id", "nextCycle": "Toolbox.GoalSettingCycle", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["status"] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "startDate"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ goalSettings: () => Toolbox.GoalSetting } as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ previousCycle: () => Toolbox.GoalSettingCycle } as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ nextCycle: () => Toolbox.GoalSettingCycle } as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θstartDate = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θstatus = Signals.proxySignalDeferred<This.GoalSettingCycleStatus>(() => (new This.GoalSettingCycleStatus(This.GoalSettingCycleStatus.Future)) as any);
    private readonly θgoalsDeadline = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θselfReviewDeadline = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θmanagerReviewDeadline = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θgoalSettings = Signals.proxySignalDeferred<Toolbox.GoalSetting[]>(() => (undefined) as any);
    private readonly θpreviousCycle = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle>(() => (undefined) as any);
    private readonly θpreviousCycleId = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle.Id>(() => (undefined) as any);
    private readonly θnextCycle = Signals.proxySignalDeferred<Toolbox.GoalSettingCycle>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSettingCycle' {
        return 'Toolbox.GoalSettingCycle'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSettingCycle' {
        return 'Toolbox.GoalSettingCycle'
    }

    static get __baseType(): 'Toolbox.GoalSettingCycle' {
        return 'Toolbox.GoalSettingCycle'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSettingCycle' {
        return 'Toolbox.GoalSettingCycle'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSettingCycle[BoInfoSymbol]
    }

    get startDate(): Date {
        return this.θstartDate?.()
    }

    set startDate(startDate) {
        this.θstartDate.set(LowgileDataUtil.coerceDataType(startDate, 'Date', false, true))
    }

    get status(): This.GoalSettingCycleStatus {
        return this.θstatus?.()
    }

    set status(status: This.GoalSettingCycleStatus | This.GoalSettingCycleStatus.Id) {
        this.θstatus().θupdate(status)
    }

    @jsonProperty(String)
    get 'status$id'(): This.GoalSettingCycleStatus.Id {
        return this.θstatus?.()?.id
    }

    set 'status$id'(status: string) {
        this.θstatus().θupdate(status as This.GoalSettingCycleStatus.Id)
    }

    get goalsDeadline(): Date {
        return this.θgoalsDeadline?.()
    }

    set goalsDeadline(goalsDeadline) {
        this.θgoalsDeadline.set(LowgileDataUtil.coerceDataType(goalsDeadline, 'Date', false, true))
    }

    get selfReviewDeadline(): Date {
        return this.θselfReviewDeadline?.()
    }

    set selfReviewDeadline(selfReviewDeadline) {
        this.θselfReviewDeadline.set(LowgileDataUtil.coerceDataType(selfReviewDeadline, 'Date', false, true))
    }

    get managerReviewDeadline(): Date {
        return this.θmanagerReviewDeadline?.()
    }

    set managerReviewDeadline(managerReviewDeadline) {
        this.θmanagerReviewDeadline.set(LowgileDataUtil.coerceDataType(managerReviewDeadline, 'Date', false, true))
    }

    get goalSettings(): Toolbox.GoalSetting[] {
        return this.θgoalSettings?.()
    }

    set goalSettings(goalSettings) {
        this.θgoalSettings.set(LowgileDataUtil.coerceDataType(goalSettings, Toolbox.GoalSetting, true, true))
        this.goalSettings?.forEach?.(item => { if (item && "cycle" in item) item.cycle = this as any })
    }

    get previousCycle(): Toolbox.GoalSettingCycle {
        return this.θpreviousCycle?.()
    }

    set previousCycle(previousCycle) {
        this.θpreviousCycle.set(LowgileDataUtil.coerceDataType(previousCycle, Toolbox.GoalSettingCycle, false, true))
        if (previousCycle) {
            this.θpreviousCycleId.set(previousCycle.id)
        } else if (previousCycle === null && previousCycle) {
            this.θpreviousCycleId.set(null)
        }
    }

    get previousCycleId(): Toolbox.GoalSettingCycle.Id {
        return this.θpreviousCycleId?.()
    }

    set previousCycleId(previousCycleId) {
        if (previousCycleId === null) this.θpreviousCycle.set(null)
        if (this.previousCycle?.id && previousCycleId != this.previousCycle.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θpreviousCycleId.set(LowgileDataUtil.coerceDataType(previousCycleId, 'Toolbox.GoalSettingCycle.Id', false, true))
    }

    get nextCycle(): Toolbox.GoalSettingCycle {
        return this.θnextCycle?.()
    }

    set nextCycle(nextCycle) {
        this.θnextCycle.set(LowgileDataUtil.coerceDataType(nextCycle, Toolbox.GoalSettingCycle, false, true))
        if (nextCycle) nextCycle.previousCycle = this as any
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__GoalSettingCycle>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                goalSettings: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSettingCycle()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSettingCycle>, restrictToClass?: Class<Partial<Toolbox__GoalSettingCycle>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            startDate: z.coerce.date(),
            get status() { return Toolbox.GoalSettingCycleStatus.$getSchema() },
            goalsDeadline: z.coerce.date(),
            selfReviewDeadline: z.coerce.date(),
            managerReviewDeadline: z.coerce.date(),
            get goalSettings() { return z.array(Toolbox.GoalSetting.$getSchema()) },
            get previousCycle() { return Toolbox.GoalSettingCycle.$getSchema() },
            get previousCycleId() { return z.number() },
            get nextCycle() { return Toolbox.GoalSettingCycle.$getSchema() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSettingCycle.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('startDate', 'status$id', 'goalsDeadline', 'selfReviewDeadline', 'managerReviewDeadline', 'goalSettings', 'previousCycle', 'previousCycleId', 'nextCycle', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    getDateRange(): string {
        if (!this.startDate) return 'N/A'
        return `${Sys.Date.format(this.startDate, 'MM.yyyy')} - ${Sys.Date.format(Sys.Date.fns.addMonths(this.startDate, 11), 'MM.yyyy')}`
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSettingCycle {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSettingCycle { }

export import GoalSettingCycle = Toolbox__GoalSettingCycle
setTimeout(() => {
    jsonProperty(() => Date)(Toolbox__GoalSettingCycle.prototype, 'startDate')
    jsonProperty(() => Date)(Toolbox__GoalSettingCycle.prototype, 'goalsDeadline')
    jsonProperty(() => Date)(Toolbox__GoalSettingCycle.prototype, 'selfReviewDeadline')
    jsonProperty(() => Date)(Toolbox__GoalSettingCycle.prototype, 'managerReviewDeadline')
    jsonArrayProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSettingCycle.prototype, 'goalSettings')
    jsonProperty(() => Toolbox.GoalSettingCycle)(Toolbox__GoalSettingCycle.prototype, 'previousCycle')
    jsonProperty(() => Toolbox.GoalSettingCycle.Id)(Toolbox__GoalSettingCycle.prototype, 'previousCycleId')
    jsonProperty(() => Toolbox.GoalSettingCycle)(Toolbox__GoalSettingCycle.prototype, 'nextCycle')
    jsonProperty(() => Date)(Toolbox__GoalSettingCycle.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingCycle.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingCycle.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingCycle.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingCycle.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingCycle.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSettingCycle.prototype, 'versionNumber')
})

export const GoalSettingCycleθId = Number;

export type GoalSettingCycleθId = number;

namespace Toolbox__GoalSettingCycle {
    export type Id = NominalType<number, 'Toolbox.GoalSettingCycle'>

}
